import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import React from 'react'
import { IconProps } from './iconBase'

/** 矢印（上向き）のアイコン */
export const ArrowUpIcon = (props: IconProps) => {
  return <ArrowUpwardIcon {...props} />
}
